<template>
  <!--保全证书-->
  <div class="certi">
    <nuxt-child/>
  </div>
</template>

<script>
  export default {
    name: "certi",
    layout: 'fullpage'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// pages/certi.vue